export interface ExportsMonitoringChannel {
    id: string;
    channelId: string;
    channelName: string;
    channelLogoUrl: string;
    lastExportDateOutput: Date;
    successRate: number;
    group: boolean;
}
export interface ExportsMonitoringChannelDrilldownExport {
    id: string;
    brandName: string;
    brandId: string;
    listingName: string;
    listingId: string;
    supplierName: string;
    companyId: string;
    exportDate: Date;
    exportType: MonitoringChannelDrilldownExportType;
    successRate: number;
    group: boolean;
}

export enum MonitoringChannelDrilldownExportType {
    UNKNWOWN = 'UNKNOWN',
    REGULAR_EXPORT = 'REGULAR_EXPORT',
    FULL_EXPORT_WITH_OVERRIDE = 'FULL_EXPORT_WITH_OVERRIDE',
    FULL_EXPORT_WITHOUT_OVERRIDE = 'FULL_EXPORT_WITHOUT_OVERRIDE',
}

export enum MonitoringChannelDateRangesEnum {
    UNKNOWN = 'UNKNOWN',
    LAST_DAY = 'LAST_DAY',
    LAST_WEEK = 'LAST_WEEK',
    LAST_MONTH = 'LAST_MONTH',
}
